import styled from 'styled-components';

export const Div = styled.div`
    display: flex;
    height: 26px;
    width: 52px;
    margin: 4px 5px;
    background-image: url("${(props) => props.imageSource}");
    margin-left: ${(props) => (props.firstInRow ? 0 : null)};
    margin-right: ${(props) => (props.lastInRow ? 0 : null)};
    cursor: url("${(props) => props.cursorSource}"), default;
    cursor: grab;
    background-position: center;
    box-sizing: border-box;
    opacity: ${({ isDragging }) => (isDragging ? 0.25 : 1)};
    transition: transform .2s ease-in;
    :hover {
        border-radius: 5px;
        border: ${({ theme }) => `1px solid ${theme.colors.primary300}`};
        box-shadow: 0px 0px 4px rgba(28, 28, 28, 0.2);
        transform: rotateZ(-3deg);
    }
`;
export const Wrapper = styled.div`
    padding: 0;
    padding-top: 10px;
    position: relative;
`;

export const LayoutBox = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-between;
    width: 100%;
    height: 100%;
`;

export const LayoutFull = styled.div`
    width: calc(100% - 12px);
    height: 10px;
    margin: 5px auto;
    background-color: #51B6FF;
`;

export const LeftHalf = styled.div`
    flex-grow: 1;
    margin: 5px 2px 4px 4px;
    width: calc(50% - 9px);
    height: 10px;
    background-color: #51B6FF;
`;

export const RightHalf = styled(LeftHalf)`
    margin: 5px 4px 4px 2px;
`;

export const FirstThird = styled(LeftHalf)`
    margin: 5px 1px 4px 4px;
    width: calc(33.33% - 8px);
`;

export const SecondThird = styled(FirstThird)`
    margin: 5px 2px 4px 4px;
`;
export const Third = styled(FirstThird)`
    margin: 5px 4px 4px 4px;
`;
export const FirstQuarter = styled(LeftHalf)`
    margin: 5px 2px 4px 4px;
    width: calc(25% - 8px);
`;

export const SecondQuarter = styled(FirstQuarter)`
    margin: 5px 2px 4px 4px;
`;

export const ThirdQuarter = styled(FirstQuarter)`
    margin: 5px 2px 4px 4px;
`;

export const FourthQuarter = styled(FirstQuarter)`
    margin: 5px 4px 4px 4px;
`;

export const Big = styled(LeftHalf)`
    margin-right: ${(props) => (props.left ? '2px' : '4px')};
    margin-left: ${(props) => (props.right ? '2px' : '4px')};
    flex-grow: 2;
    width: calc(66.67% - 9px);
`;

export const Small = styled(RightHalf)`
    margin-right: ${(props) => (props.left ? '2px' : '4px')};
    margin-left: ${(props) => (props.right ? '2px' : '4px')};
    width: calc(33.33% - 9px);
`;

export const Medium = styled(LeftHalf)`
    flex-grow: 2;
    margin: ${(props) => (props.left ? '5px 2px 4px 4px' : '5px 4px 4px 4px')};
    width: calc(50% - 8px);
    margin-right: ${(props) => (props.right ? '4px' : '2px')};
    margin-left: ${(props) => (props.left ? '4px' : '2px')};
`;

export const MediumSmall = styled(LeftHalf)`
    margin: 5px 2px 4px 2px;
    width: calc(25% - 8px);
    margin-left: ${(props) => (props.first ? '4px' : '2px')};
    margin-right: ${(props) => (props.last ? '4px' : '2px')};
`;
